import React, { useEffect } from 'react';
import styles from './enrichment-ip-reputation.module.sass';
import { Typography, Tooltip, Table } from 'antd';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';
import ProgressBar from '../../../../shared-components/ProgressBar';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import { RightOutlined, InfoCircleFilled } from '@ant-design/icons';

function EnrichmentIPReputation({ newData, statusNew }) {
  const { Title, Text } = Typography;
  let ipReputation = undefined;

  if (newData?.response?.ip2asn) {
    ipReputation = newData?.response?.ip2asn?.[0];
  }

  const columns = [
    {
      title: <ColumnTitle columnName="Name" />,
      dataIndex: 'name',
      key: 'name',
      render: (value, params) => {
        if (params.tooltip) {
          return (
            <>
              {value + ' '}
              <Tooltip placement="top" title={params.tooltip}>
                <InfoCircleFilled />
              </Tooltip>
            </>
          );
        } else {
          return value;
        }
      },
    },
    {
      title: <ColumnTitle columnName="Value" />,
      dataIndex: 'value',
      key: 'value',
    },
    {
      dataIndex: 'progress',
      key: 'progress',
      width: 100,
    },
    {
      dataIndex: 'expandIcon',
      key: 'expandIcon',
      align: 'right',
    },
  ];

  function returnTableData({ loading }) {
    return [
      {
        key: 1,
        name: 'IP Reputation',
        tooltip:
          'Score calculated on the number of domain names currently listed on a feed that are hosted on this IP',
        value: loading ? (
          <LoadingSkeleton />
        ) : (
          <>
            <Text strong>{ipReputation?.ip_reputation ?? '-'}</Text>{' '}
          </>
        ),
        children: [
          {
            key: 11,
            name: 'IP Density',
            tooltip: 'The number of A records pointing to this IP address',
            value: (
              <Text strong>
                {ipReputation?.ip_reputation_explain?.ip_density ?? '-'}
              </Text>
            ),
            expandable: false,
            progress: null,
          },
          {
            key: 12,
            name: 'Domains Names Listed',
            tooltip:
              'List of current domain names that are currently listed on a feed pointing to this IP',
            value: (
              <Text strong>
                {ipReputation?.ip_reputation_explain?.names_num_listed ?? '-'}
              </Text>
            ),
            expandable: false,
            progress: null,
          },
        ],
        progress: loading ? (
          <LoadingSkeleton />
        ) : (
          <ProgressBar
            bgcolor={ipReputation?.ip_reputation}
            width={'72'}
            completed={ipReputation?.ip_reputation}
          />
        ),
        expandIcon: (
          <Text strong>
            <RightOutlined id="1" className={styles.expand_indicator} />
          </Text>
        ),
      },
    ];
  }

  return (
    <div
      id="enrichmentIpReputation"
      className={styles.enrichment_ip_reputation}
    >
      <div className={styles.title}>
        <Title level={4}>IP Reputation</Title>
        <Text>
          Score calculated on the number of domain names currently listed on a
          feed that are hosted on this IP.
          <Text strong> Silent Push invention</Text>
        </Text>
      </div>
      <Table
        columns={columns}
        pagination={false}
        expandable={{
          rowExpandable: (record) => record?.children !== undefined,
          expandIcon: ({ expanded, onExpand, record }) => {
            if (statusNew === 'loaded') {
              if (expanded && record?.expandIcon) {
                if (
                  document.getElementById(record?.key) &&
                  record?.expandIcon
                ) {
                  document
                    .getElementById(record?.key)
                    .classList.add('expanded');
                }
              } else {
                if (
                  document.getElementById(record?.key) &&
                  record?.expandIcon
                ) {
                  document
                    .getElementById(record?.key)
                    .classList.remove('expanded');
                }
              }
            }
            return <></>;
          },
          expandRowByClick: true,
          defaultExpandAllRows: false,
        }}
        dataSource={returnTableData({ loading: statusNew === 'loading' })}
      />
    </div>
  );
}

export default EnrichmentIPReputation;
